import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { ALL_PAYMENT_STATUSES, PAYMENT_ENUMS } from '../../../../core/constants/payments';
import { PROJECT_TYPES_ENUMS } from '../../../../core/constants/projects';
import { formatDateWithEstTimezone } from '../../../../core/utils/format-date';

import {
  Table,
  Text,
  Link,
  EditableColumn,
} from './styles';

const CustomTable = (props) => {
  const {
    payments,
    onOpenStatusModal,
    onOpenVideo,
  } = props;

  return (
    <Table basic="very">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            <Text.Bold>Workspace</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Payment date</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Tester name</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Paypal</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Completed on</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Test ID</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Payment amount</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Study type</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Payment status</Text.Bold>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {!_.isEmpty(payments) && _.map(payments, (payment) => {
          const {
            id,
            status,
            convertedAmount,
            paypalAccount,
            paymentDate,
            tester: {
              id: testerId,
              project: {
                id: projectId, company, testType, shareCode,
              },
              user: { profile },
              testSessions = [],
            },
          } = payment;

          const { firstName, lastName } = profile;
          const { completedAt } = testSessions[0];

          const hasVideo = testType === PROJECT_TYPES_ENUMS.UNMODERATED || testType === PROJECT_TYPES_ENUMS.MODERATED;
          const object = { id, status };

          return (
            <Table.Row key={id}>
              <Table.Cell>
                <Text.Bold>{company.name}</Text.Bold>
              </Table.Cell>

              <Table.Cell>
                <Text>
                  {(paymentDate && formatDateWithEstTimezone(paymentDate)) || 'N/A'}
                </Text>
              </Table.Cell>

              <Table.Cell>
                <Text.Bold>
                  <Link onClick={() => hasVideo && onOpenVideo(projectId, testerId)}>
                    {`${firstName} ${lastName}`}
                  </Link>
                </Text.Bold>
              </Table.Cell>

              <Table.Cell>
                <Text>{paypalAccount}</Text>
              </Table.Cell>

              <Table.Cell>
                <Text>{(completedAt && formatDateWithEstTimezone(completedAt)) || 'N/A'}</Text>
              </Table.Cell>

              <Table.Cell>
                <Text>{shareCode || 'N/A'}</Text>
              </Table.Cell>

              <Table.Cell>
                <Text>{convertedAmount}</Text>
              </Table.Cell>

              <Table.Cell>
                <Text>{_.startCase(testType)}</Text>
              </Table.Cell>

              <Table.Cell>
                <EditableColumn>
                  <Text>
                    {ALL_PAYMENT_STATUSES[status]}
                  </Text>

                  {(status === PAYMENT_ENUMS.pending || status === PAYMENT_ENUMS.rejected) && (
                    <Link
                      onClick={() => onOpenStatusModal(object)}
                    >
                      Change Status
                    </Link>
                  )}
                </EditableColumn>
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};

CustomTable.propTypes = {
  onOpenStatusModal: PropTypes.func.isRequired,
  onOpenVideo: PropTypes.func.isRequired,
  payments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      status: PropTypes.string,
      convertedAmount: PropTypes.string,
      paypalAccount: PropTypes.string,
      paymentDate: PropTypes.string,
      tester: PropTypes.shape({
        id: PropTypes.string,
        user: PropTypes.shape({
          id: PropTypes.string,
          firstName: PropTypes.string,
          lastName: PropTypes.string,
        }).isRequired,
        project: PropTypes.shape({
          id: PropTypes.string,
          testType: PropTypes.string,
          company: PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
          }).isRequired,
          shareCode: PropTypes.string,
        }).isRequired,
        testSessions: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            completedAt: PropTypes.string,
          }).isRequired,
        ).isRequired,
      }).isRequired,
    }).isRequired,
  ).isRequired,
};

export default CustomTable;
